var React = require('react');

function DesktopClosed (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#FFF","fillRule":"nonzero"},[React.createElement("path",{"d":"M13.549 2.03L26.36 14.843c.272.272.643.342.828.157l.84-.839c.184-.185.114-.556-.158-.828L15.059.52c-.272-.273-.643-.343-.828-.158l-.84.84c-.185.185-.114.555.158.828z","key":0}),React.createElement("path",{"d":"M27.98 1.916L15.1 14.796c-.273.273-.653.337-.848.142l-.883-.883c-.195-.195-.132-.575.142-.849L26.39.326c.273-.273.653-.336.848-.141l.883.883c.195.195.131.575-.142.848z","key":1})]));
}

DesktopClosed.defaultProps = {"width":"41","height":"15"};

module.exports = DesktopClosed;

DesktopClosed.default = DesktopClosed;
